import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Set alignment of Icon and Text horizontally.
   */ horizontal: PropTypes.bool
};
/**
 * @deprecated Use a pattern of other SWAN components instead.
 */ const IconTileSet = deprecatedComponent({
    displayName: 'IconTileSet',
    description: 'IconTileSet is deprecated; use a pattern of other SWAN components instead. See the doc site for more information.',
    root: createComponent({
        displayName: 'IconTileSet',
        root: 'div',
        propTypes,
        propConfig: {
            classNames (props) {
                const classNameSet = new Set([
                    'swan-icon-tile-set'
                ]);
                const { horizontal = false } = props;
                if (horizontal) classNameSet.add(`swan-icon-tile-set-horizontal`);
                return classNameSet;
            }
        }
    })
});
IconTileSet.defaultProps = {
    horizontal: false
};

export { IconTileSet };
